// extracted by mini-css-extract-plugin
module.exports = {"stablecoinWrap":"Stablecoin_stablecoinWrap__1_pRo","large":"Stablecoin_large__VmEbc"};